import getDataProgram from "./getDataProgram";
import modalMissProgMain from "./modalMissProgMain";

const shortForm = (requestPrograms) => {
  const formBlock = document.getElementById("shortForm");

  if (!formBlock) {
    return;
  }

  try {
    if (requestPrograms.length > 0) {
      const loader = document.querySelector(".monitoring__loader");

      loader.classList.remove("active");
      formBlock.style.display = "block";
    }
  } catch (e) {
    console.log(e);
  }

  const Regions = document.getElementById("shortFormRegions"),
    Program = document.getElementById("shortFormProgram"),
    link = document.getElementById("shortForm-link");

  let region = "",
    program = "",
    allPrograms = requestPrograms,
    filterNoDublicatePrograms = [],
    filterPrograms = [],
    allProgramsRegion = [];

  /* Событие на изменение поля Регионы */
  Regions.onchange = function (e) {
    region = e.target.value;

    let programsDublicate = structuredClone(allPrograms);

    filterNoDublicatePrograms = [];

    programsDublicate.forEach((item) => {
      if (item.fields.length > 0) {
        item.Redirect = true;

        item.regions.forEach((el) => {
          if (el.fields.length <= 2) {
            el.isNotRedirect = true;
          }
        });
      }
    });

    filterNoDublicatePrograms = programsDublicate.filter(
      (item) => item.Redirect
    );

    filterNoDublicatePrograms.forEach((item) => {
      item.regions = item.regions.filter((el) => !el.isNotRedirect);
    });

    filterNoDublicatePrograms = filterNoDublicatePrograms.filter((item) =>
      item.regions.some((it) => it.region_id == region)
    );

    /* Добавление в переменную всех возможных программ для данного региона для отслеживания логики вывода модального окна с нужным сообщением */
    allProgramsRegion = [];
    allProgramsRegion = structuredClone(filterNoDublicatePrograms);

    logicFieldCategory();
    renderOptions(filterPrograms);
  };

  /* Добавление ссылки на кнопку */
  Program.onchange = function (e) {
    program = e.target.value;

    if (region != "") {
      let data = getDataProgram(filterNoDublicatePrograms, e, region);

      /* Добавление аттрибута ссылки на РВР */
      e.target.options[e.target.selectedIndex].setAttribute(
        "linkrvr",
        data?.link
      );

      /* Добавление аттрибута оператора */
      e.target.options[e.target.selectedIndex].setAttribute(
        "operator",
        data?.operator
      );

      /* Добавление аттрибута id программы */
      e.target.options[e.target.selectedIndex].setAttribute(
        "program_id",
        data?.program_id
      );

      /* Добавляем ссылку на РВР в кнопку */
      link.classList.remove("disabled");
      link.href = data?.link;
      link.addEventListener("click", () => {
        if (window.yaCounter94760218) {
          ym(94760218, "reachGoal", "form_short");
        }
      });
    }
  };

  /* Логика на поле Категории */
  function logicFieldCategory() {
    link.classList.add("disabled");
    filterPrograms = filterNoDublicatePrograms;

    if (region != "") {
      modalMissProgMain(
        Regions,
        filterPrograms,
        filterNoDublicatePrograms,
        allProgramsRegion
      );
    }
  }

  /* Создаем нужные options */
  function renderOptions(arr) {
    [...Program.children].map((item, idx) => {
      if (idx > 0) {
        item.remove();
      }
    });

    arr.forEach((item) => {
      let option = new Option(item.name, item.name, false, false);
      option.setAttribute("shortname", item.shortname);

      Program.append(option);
    });
  }
};

export default shortForm;
